export const COLOR_BLACK = 'rgb(0, 0, 0)'
export const COLOR_WHITE = 'rgb(255, 255, 255)'

// Brand Black
export const COLOR_BRAND_BLACK_50 = 'rgb(238, 238, 238)'
export const COLOR_BRAND_BLACK_100 = 'rgb(210, 210, 210)'
export const COLOR_BRAND_BLACK_200 = 'rgb(168, 168, 168)'
export const COLOR_BRAND_BLACK_300 = 'rgb(106, 106, 106)'
export const COLOR_BRAND_BLACK_400 = 'rgb(40, 40, 40)'
export const COLOR_BRAND_BLACK_500 = 'rgb(13, 13, 13)'
export const COLOR_BRAND_BLACK_600 = 'rgb(11, 11, 11)'
export const COLOR_BRAND_BLACK_700 = 'rgb(9, 9, 9)'
export const COLOR_BRAND_BLACK_800 = 'rgb(8, 8, 8)'
export const COLOR_BRAND_BLACK_900 = 'rgb(7, 7, 7)'
export const COLOR_BRAND_BLACK_950 = 'rgb(2, 2, 2)'

// Brand Grey
export const COLOR_BRAND_GREY_50 = 'rgb(241, 241, 241)'
export const COLOR_BRAND_GREY_100 = 'rgb(216, 216, 216)'
export const COLOR_BRAND_GREY_200 = 'rgb(181, 181, 181)'
export const COLOR_BRAND_GREY_300 = 'rgb(128, 128, 128)'
export const COLOR_BRAND_GREY_400 = 'rgb(70, 70, 70)'
export const COLOR_BRAND_GREY_500 = 'rgb(43, 43, 43)'
export const COLOR_BRAND_GREY_600 = 'rgb(37, 37, 37)'
export const COLOR_BRAND_GREY_700 = 'rgb(31, 31, 31)'
export const COLOR_BRAND_GREY_800 = 'rgb(27, 27, 27)'
export const COLOR_BRAND_GREY_900 = 'rgb(24, 24, 24)'
export const COLOR_BRAND_GREY_950 = 'rgb(17, 17, 17)'

// Brand Orange
export const COLOR_BRAND_ORANGE_50 = 'rgb(254, 243, 242)'
export const COLOR_BRAND_ORANGE_100 = 'rgb(254, 228, 226)'
export const COLOR_BRAND_ORANGE_200 = 'rgb(255, 205, 201)'
export const COLOR_BRAND_ORANGE_300 = 'rgb(253, 170, 164)'
export const COLOR_BRAND_ORANGE_400 = 'rgb(250, 121, 111)'
export const COLOR_BRAND_ORANGE_500 = 'rgb(241, 67, 54)'
export const COLOR_BRAND_ORANGE_600 = 'rgb(223, 48, 35)'
export const COLOR_BRAND_ORANGE_700 = 'rgb(188, 36, 25)'
export const COLOR_BRAND_ORANGE_800 = 'rgb(155, 34, 25)'
export const COLOR_BRAND_ORANGE_900 = 'rgb(129, 34, 27)'
export const COLOR_BRAND_ORANGE_950 = 'rgb(70, 13, 9)'

// Brand Blue
export const COLOR_BRAND_BLUE_50 = 'rgb(234, 235, 250)'
export const COLOR_BRAND_BLUE_100 = 'rgb(212, 214, 240)'
export const COLOR_BRAND_BLUE_200 = 'rgb(177, 183, 231)'
export const COLOR_BRAND_BLUE_300 = 'rgb(124, 135, 213)'
export const COLOR_BRAND_BLUE_400 = 'rgb(64, 76, 188)'
export const COLOR_BRAND_BLUE_500 = 'rgb(34, 36, 96)'
export const COLOR_BRAND_BLUE_600 = 'rgb(36, 34, 82)'
export const COLOR_BRAND_BLUE_700 = 'rgb(37, 34, 71)'
export const COLOR_BRAND_BLUE_800 = 'rgb(33, 30, 57)'
export const COLOR_BRAND_BLUE_900 = 'rgb(29, 27, 45)'
export const COLOR_BRAND_BLUE_950 = 'rgb(23, 22, 33)'

// Brand Purple
export const COLOR_BRAND_PURPLE_50 = 'rgb(253, 233, 255)'
export const COLOR_BRAND_PURPLE_100 = 'rgb(251, 211, 255)'
export const COLOR_BRAND_PURPLE_200 = 'rgb(247, 165, 255)'
export const COLOR_BRAND_PURPLE_300 = 'rgb(247, 93, 255)'
export const COLOR_BRAND_PURPLE_400 = 'rgb(243, 0, 255)'
export const COLOR_BRAND_PURPLE_500 = 'rgb(64, 0, 67)'
export const COLOR_BRAND_PURPLE_600 = 'rgb(49, 4, 50)'
export const COLOR_BRAND_PURPLE_700 = 'rgb(41, 3, 41)'
export const COLOR_BRAND_PURPLE_800 = 'rgb(33, 3, 33)'
export const COLOR_BRAND_PURPLE_900 = 'rgb(28, 3, 27)'
export const COLOR_BRAND_PURPLE_950 = 'rgb(16, 0, 16)'

// Brand Yellow
export const COLOR_BRAND_YELLOW_50 = 'rgb(255, 252, 237)'
export const COLOR_BRAND_YELLOW_100 = 'rgb(255, 247, 202)'
export const COLOR_BRAND_YELLOW_200 = 'rgb(255, 237, 144)'
export const COLOR_BRAND_YELLOW_300 = 'rgb(255, 222, 87)'
export const COLOR_BRAND_YELLOW_400 = 'rgb(255, 203, 42)'
export const COLOR_BRAND_YELLOW_500 = 'rgb(255, 177, 25)'
export const COLOR_BRAND_YELLOW_600 = 'rgb(248, 141, 0)'
export const COLOR_BRAND_YELLOW_700 = 'rgb(205, 97, 2)'
export const COLOR_BRAND_YELLOW_800 = 'rgb(166, 74, 9)'
export const COLOR_BRAND_YELLOW_900 = 'rgb(136, 60, 11)'
export const COLOR_BRAND_YELLOW_950 = 'rgb(79, 31, 0)'

export const parseRGB = (rgb: string, separator: string = ' ') => {
  const matches = rgb.match(/\d+/g)
  return matches ? matches.join(separator) : ''
}

export const getRGBA = (rgb: string, opacity: number = 1.0) => `rgba(${parseRGB(rgb, ', ')}, ${opacity})`
